const sansSerif = 'sans-serif';
const avantGardeGothicPRO = `itc-avant-garde-gothic-pro, ${sansSerif}`;
const ptSans = `pt-sans, ${sansSerif}`;
const quatro = `quatro, ${sansSerif}`;
const proxima_nova1 = 'proxima-nova';
const proxima_nova2 = 'proxima_nova';
const proxima = `${proxima_nova1}, ${proxima_nova2}, ${sansSerif}`;
const sofia = `sofia-pro-soft, ${sansSerif}`;
const rooneySans = `Rooney Sans`;

const fonts = {
  sansSerif,
  avantGardeGothicPRO,
  ptSans,
  quatro,
  proxima_nova1,
  proxima_nova2,
  proxima,
  sofia,
  rooneySans,
};

module.exports = fonts;
